import { Token } from '@sushiswap/currency'
import { FuroChainId } from '@sushiswap/furo-sdk'
import { FURO_SUBGRAPH_URL } from '@sushiswap/graph-config'
import { useQuery } from '@tanstack/react-query'

import { bentoBoxRebaseQuery, getBuiltGraphSDK } from '../../.graphclient'

import { fetchWithTimeout } from './fetchWithTimeout'

interface UseRebaseDTO {
  tokens: Token[]
  enabled?: boolean
}

export const queryRebasesDTO = async ({ tokens }: Omit<UseRebaseDTO, 'enabled'>) => {
  const sdks = tokens.map((token) =>
    getBuiltGraphSDK({
      chainId: token.chainId,
      url: FURO_SUBGRAPH_URL[token.chainId]
    })
  )

  const results = await Promise.allSettled(
    sdks.map((sdk, i) =>
      fetchWithTimeout(() => sdk.bentoBoxRebase({
        id: tokens[i].wrapped.address.toLowerCase(),
      }))
    )
  )

  return results.map((result, i) => {
    if (result.status === 'fulfilled') {
      return {
        chainId: tokens[i].chainId as FuroChainId,
        data: result.value as NonNullable<bentoBoxRebaseQuery>,
      }
    }
    return {
      chainId: tokens[i].chainId as FuroChainId,
      data: { rebase: null } as NonNullable<bentoBoxRebaseQuery>,
    }
  })
}

export const useRebasesDTO = ({ tokens, enabled = true }: UseRebaseDTO) => {
  return useQuery({
    queryKey: ['useRebasesDTO', { tokens }],
    queryFn: async () => await queryRebasesDTO({ tokens }),
    enabled: Boolean(enabled),
  })
}
